export default __webpack_public_path__ + "static/media/man.2a2f851d.svg";